export enum AccessStatus {
  APPROVE = 'approve',
  DECLINE = 'decline'
}
